/* import __COLOCATED_TEMPLATE__ from './external-reference.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import type Conversation from 'embercom/objects/inbox/conversation';
import { ExternalType } from 'embercom/objects/standalone/constants';

interface Signature {
  Args: {
    conversation: Conversation;
  };
}

export default class ExternalReference extends Component<Signature> {
  get labelIntlKey(): string {
    let externalType = this.args.conversation.externalType;
    switch (externalType) {
      case ExternalType.ZendeskTicket:
        return 'inbox.conversation-details.external-reference.zendesk-ticket-label';
      case ExternalType.SalesforceCase:
        return 'inbox.conversation-details.external-reference.salesforce-case-label';
      case ExternalType.HubspotConversation:
        return 'inbox.conversation-details.external-reference.hubspot-conversation-label';
      case ExternalType.FreshdeskTicket:
        return 'inbox.conversation-details.external-reference.freshdesk-ticket-label';
      case ExternalType.FreshchatConversation:
        return 'inbox.conversation-details.external-reference.freshchat-conversation-label';
      default:
        return 'inbox.conversation-details.external-reference.external-reference-label';
    }
  }

  get externalId(): string | undefined {
    return this.args.conversation.externalReference?.external_id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::ExternalReference': typeof ExternalReference;
    'inbox2/conversation-details-sidebar/external-reference': typeof ExternalReference;
  }
}
